import { render, staticRenderFns } from "./contenidos.vue?vue&type=template&id=0e275d28"
import script from "./contenidos.vue?vue&type=script&lang=js"
export * from "./contenidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports